exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody[data-v-6337939f]{\n\toverflow:hidden\n}\n", ""]);

// exports
